export class ActivityModel {
  id: number;
  name: string;
  parameter: string;
  accountId: number;

  constructor(data: any) {
    this.id = data.id ? data.id : 0;
    this.name = data.name ? data.name : '';
    this.parameter = data.parameter ? data.parameter : '';

    this.accountId = data.accountId ? data.accountId : null;
  }
}
